import React, { useEffect, useState, useRef } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Grid, Typography, Button, IconButton, Checkbox } from '@mui/material';
import { useForm, Controller, SubmitHandler, useFieldArray } from 'react-hook-form';
import { Label } from 'reactstrap';
import { gridSpacing } from '../../store/constant';
import axiosInstance from '../../axiosInstance';
import configData from '../../config';
import { Divider, ListItemIcon } from '@mui/material';

const EditModal = ({ generateReportId, toggleEditModal, editModal, tableRowData, setTableRowData, getReportList }) => {
    const [updateReportData, setUpdateReportData] = useState(false);

    const {
        control,
        register,
        handleSubmit,
        watch,
        formState: { errors },
        setValue
    } = useForm({
        defaultValues: {
            children: [
                // {
                //     sub_report_name: '',
                //     powerbi_url: ''
                // }
            ]
        }
    });

    const {
        fields: children,
        append: appendChildren,
        remove: removeChildren
    } = useFieldArray({
        control,
        name: 'children'
    });

    const addChildren = () => {
        appendChildren({
            sub_report_name: '',
            powerbi_url: ''
        });
    };

    useEffect(() => {
        if (tableRowData) {
            setValue('reportName', tableRowData.title);
            setValue('powerbi_URL', tableRowData.embedURL);
        }
    }, [tableRowData]);

    const updateReport = async (data) => {
        const mainReportData = [];
        const report_id = tableRowData.id;
        data.report_id = report_id;
        const newReport = {
            report_id: report_id,
            reportName: data.reportName,
            powerbi_URL: data.powerbi_URL
        };
        console.log(data, newReport);
        data.children.length > 0 &&
            data.children.forEach((item, index) => {
                const report = {
                    id: generateReportId(item.sub_report_name),
                    title: item.sub_report_name,
                    type: 'item',
                    url: '/power-bi-report-page',
                    embedURL: item.powerbi_url,
                    breadcrumbs: false,
                    parent_id: report_id,
                    isChild: true
                };
                mainReportData.push(report);
            });
        if (data.children.length > 0){
            console.log(mainReportData);
        }   
        try {
            const response = await axiosInstance.post(configData.API_SERVER + '/user/create_reports', mainReportData);
            console.log(response);
        } catch (error) {
            console.log(error);
        }
        try {
            const res = await axiosInstance.put(configData.API_SERVER + `/user/edit_report_by_id`, newReport);
            // const res = await axiosInstance.put(`http://127.0.0.1:8000/user/edit_report_by_id`, newReport)
            console.log(res);
            getReportList();
            setTableRowData();
            toggleEditModal();
            alert(res.data.message);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <React.Fragment>
            <Modal isOpen={editModal} toggle={toggleEditModal} backdrop={true} centered={true} size="lg">
                <ModalHeader
                    toggle={() => {
                        setTableRowData();
                        toggleEditModal();
                    }}
                >
                    Edit Report
                </ModalHeader>
                <ModalBody style={{ height: '65vh' }}>
                    <Grid spacing={2} style={{ height: '60vh', overflowX: 'auto', marginTop: '0px' }}>
                        <form onSubmit={handleSubmit(updateReport)}>
                            <Grid container spacing={gridSpacing} style={{ padding: '10px' }}>
                                <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1 " style={{ flexWrap: 'wrap' }}>
                                    <Grid item lg={3} md={3} sm={12} className="">
                                        <Label style={{ fontSize: '14px !important' }}>
                                            Report Name<span style={{ color: 'red' }}>*</span>
                                        </Label>
                                    </Grid>
                                    <Grid item lg={9} md={9} sm={12} className="">
                                        <input
                                            // type="text"
                                            className="form-control "
                                            placeholder="Report Name"
                                            style={{ width: '90% !important', marginBottom: '1.3vh' }}
                                            {...register('reportName', { required: 'Report Name Is Required' })}
                                        />
                                        {errors.reportName && (
                                            <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-1px' }}>
                                                {errors.reportName.message}
                                            </p>
                                        )}
                                    </Grid>
                                    {tableRowData && !tableRowData.isChild && (
                                        <>
                                            <Grid item lg={12} sm={12} md={12} className="">
                                                <div className="d-flex">
                                                    <Checkbox
                                                        style={{ marginTop: '-8px' }}
                                                        checked={updateReportData} // Set checked state
                                                        onChange={(event) => setUpdateReportData(event.target.checked)} // Handle checkbox change
                                                    />
                                                    <p style={{ marginTop: '10px' }}>Add report in current report group</p>
                                                </div>
                                            </Grid>
                                            {updateReportData && (
                                                <>
                                                    {children.map((item, index) => (
                                                        <div key={index}>
                                                            <Divider />
                                                            <Grid container spacing={gridSpacing} style={{ padding: '10px' }}>
                                                                <Grid
                                                                    item
                                                                    lg={12}
                                                                    sm={12}
                                                                    md={12}
                                                                    className="al_sl__main_grid1"
                                                                    style={{ flexWrap: 'wrap' }}
                                                                >
                                                                    <Grid item lg={3} md={3} sm={12} className="">
                                                                        <Label style={{ fontSize: '14px !important' }}>
                                                                            Report Name<span style={{ color: 'red' }}>*</span>
                                                                        </Label>
                                                                    </Grid>
                                                                    <Grid item lg={9} md={9} sm={12} className="">
                                                                        <input
                                                                            // type="text"
                                                                            className="form-control "
                                                                            placeholder="Report Name"
                                                                            style={{ width: '80% !important', marginBottom: '1.3vh' }}
                                                                            {...register(`children.${index}.sub_report_name`, {
                                                                                required: 'Report Name Is Required'
                                                                            })}
                                                                        />
                                                                        {errors?.children?.[index]?.sub_report_name && (
                                                                            <p
                                                                                style={{
                                                                                    color: '#dc3545e6',
                                                                                    fontSize: '13px',
                                                                                    marginTop: '-1px'
                                                                                }}
                                                                            >
                                                                                {errors.children[index].sub_report_name.message}
                                                                            </p>
                                                                        )}
                                                                    </Grid>
                                                                    <Grid item lg={3} md={3} sm={12} className="">
                                                                        <Label style={{ fontSize: '14px !important' }}>
                                                                            PowerBI URL<span style={{ color: 'red' }}>*</span>
                                                                        </Label>
                                                                    </Grid>
                                                                    <Grid item lg={9} md={9} sm={12} className="">
                                                                        <input
                                                                            // type="text"
                                                                            className="form-control "
                                                                            placeholder="Report URL"
                                                                            style={{ width: '90% !important', marginBottom: '1.3vh' }}
                                                                            {...register(`children.${index}.powerbi_url`, {
                                                                                required: 'Url is required Is Required'
                                                                            })}
                                                                        />
                                                                        {errors?.children?.[index]?.powerbi_url && (
                                                                            <p
                                                                                style={{
                                                                                    color: '#dc3545e6',
                                                                                    fontSize: '13px',
                                                                                    marginTop: '-1px'
                                                                                }}
                                                                            >
                                                                                {errors.children[index].powerbi_url.message}
                                                                            </p>
                                                                        )}
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </div>
                                                    ))}{' '}
                                                    <Grid item lg={12} sm={12} md={12} className=""></Grid>
                                                    <Button style={{ marginLeft: '15px', marginTop: '10px' }} onClick={addChildren}>
                                                        Add More Reports
                                                    </Button>{' '}
                                                </>
                                            )}
                                        </>
                                    )}

                                    {tableRowData && tableRowData.type === 'item' && (
                                        <>
                                            <Grid item lg={3} md={3} sm={12} className="mt-3">
                                                <Label style={{ fontSize: '14px !important' }}>
                                                    PowerBI URL<span style={{ color: 'red' }}>*</span>
                                                </Label>
                                            </Grid>
                                            <Grid item lg={9} md={9} sm={12} className="mt-3">
                                                <input
                                                    // type="text"
                                                    className="form-control "
                                                    placeholder="Report URL"
                                                    style={{ width: '90% !important', marginBottom: '1.3vh' }}
                                                    {...register('powerbi_URL', { required: 'Report Name Is Required' })}
                                                />
                                                {errors.powerbi_URL && (
                                                    <p style={{ color: '#dc3545e6', fontSize: '13px' }}>{errors.powerbi_URL.message}</p>
                                                )}
                                            </Grid>
                                        </>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid item lg={12} sm={12} md={12}>
                                <Grid item lg={12} sm={12}>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="success"
                                        style={{ marginLeft: '15px', color: 'white' }}
                                        onClick={() => {
                                            handleSubmit(updateReport);
                                        }}
                                    >
                                        Update Details
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Grid>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};

export default EditModal;
